export default function ForestNightsIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="10" fill="#0E1433" />
      <circle cx="50" cy="13" r="7" fill="#EEF2FF" />
      <circle cx="53" cy="11" r="6" fill="#0E1433" />
      <path d="M8 40L16 18L24 40Z" fill="#1F5A2A" />
      <path d="M40 40L50 14L60 40Z" fill="#1F5A2A" />
      <circle cx="32" cy="46" r="20" fill="#FF8A1F" opacity="0.25" />
      <path d="M20 54h24" stroke="#6B4424" strokeWidth="5" strokeLinecap="round" />
      <path d="M22 52C22 42 30 40 32 28C36 38 44 42 42 52Z" fill="#FF5A1A" />
      <path d="M26 52C26 46 31 44 32 37C35 43 39 46 38 52Z" fill="#FFB52E" />
      <path d="M29 52C29 49 31 47 32 44C34 47 35 49 35 52Z" fill="#FFF1A8" />
      <circle cx="8" cy="28" r="1.6" fill="#8AFFDC" />
      <circle cx="14" cy="28" r="1.6" fill="#8AFFDC" />
      <circle cx="11" cy="31" r="1.3" fill="#8AFFDC" />
    </svg>
  );
}
